import { defaultMasteryLabels } from "@constants/common";
import { useAppStore } from "@hooks/useAppStore";
import type { Distribution } from "@memorang/types";
const getMasteryLabels = () => {
	const masteryLabels = useAppStore.getState().app.masteryLabels;
	return masteryLabels || defaultMasteryLabels;
};
//TODO: Move this to app_config table
export const masteryLevels = [
	{
		id: "basic",
		darkColor: "rgba(212, 84, 84, 1)",
		lightColor: "rgba(191, 0, 0, 1)",
		sortOrder: 4,
		icon: "speedometer-slow",
		range: {
			type: "formative",
			score: [0, 39],
			points: [0, 6],
		},
		alias: {
			title: "session.masteryLevels.basic",
		},
	},
	{
		id: "lowIntermediate",
		darkColor: "rgba(181, 77, 33, 1)",
		lightColor: "rgba(255, 143, 96, 1)",
		sortOrder: 3,
		icon: "speedometer-medium",
		range: {
			type: "formative",
			score: [40, 59],
			points: [7, 12],
		},
		alias: {
			title: "session.masteryLevels.lowIntermediate",
		},
	},
	{
		id: "highIntermediate",
		darkColor: "#77851C",
		lightColor: "#6A780E",
		sortOrder: 2,
		icon: "speedometer",
		range: {
			type: "formative",
			score: [60, 79],
			points: [13, 16],
		},
		alias: {
			title: "session.masteryLevels.highIntermediate",
		},
	},
	{
		id: "advanced",
		darkColor: "rgba(82, 167, 141, 1)",
		lightColor: "rgba(0, 129, 89, 1)",
		sortOrder: 1,
		icon: "speedometer",
		range: {
			type: "formative",
			score: [80, 100],
			points: [17, 30],
		},
		alias: {
			title: "session.masteryLevels.advanced",
		},
	},
] as const;

export const sortedMasteryLevels = [...masteryLevels].sort(
	(a, b) => a.sortOrder - b.sortOrder,
);

export const calculateNumAttempts = (distribution: Distribution) => {
	return Object.keys(distribution)
		.filter((key) => key !== "none")
		.reduce((b, d) => b + distribution[d as keyof Distribution], 0);
};
export { getMasteryLabels };
